import React from 'react';
import styled from 'styled-components';
import { significanceColors } from '../../utils';
import {
  defaultNumberFormatOptions,
  globalFormat,
} from '../../../../../utils/formatting';

interface IProps {
  relativePerformance: number;
  isLeading: boolean;
}

const LeadingBadge = styled.span`
  margin-left: 5px;
  display: inline-flex;
  align-items: center;
  column-gap: 2px;
  flex: 0 0 auto;
  padding-right: 3px;
  padding-left: 3px;
  border-radius: 2px;
  border: 1px solid ${significanceColors.success};
  background-color: #def2e8ff;
  font-weight: 600;
  text-transform: uppercase;
  line-height: normal;
  color: ${significanceColors.success};
`;

const SignificanceLiftValue = ({ relativePerformance, isLeading }: IProps) => {
  return (
    <>
      <span
        style={{
          color:
            relativePerformance > 0
              ? significanceColors.success
              : significanceColors.danger,
        }}
      >
        {globalFormat.formatNumber(
          relativePerformance,
          defaultNumberFormatOptions.percent,
        )}
      </span>
      {isLeading && <LeadingBadge>Leading</LeadingBadge>}
    </>
  );
};

export default SignificanceLiftValue;
